export default {
    'voucher': 'Pre-registration',
    'moduleName': 'Pre-register for others',
    'addButton': 'Add a person',
    'table': {
      'name': 'Name',
      'email': 'Email',
      'confirmation': 'Confirmation',
      'badge': 'Badge',
      'createTime': 'Create Time',
      'status': 'Status'
    },
    'dialogBadgeTitle': 'Download chest card',
    'dialogBadgeSubTitle': 'You can download the chest card here',
    'BUYER': 'BUYER 买家',
    'PurChasing Agent': 'PurChasing Agent 采购买家',
    'dialogCTitle': 'Download confirmation',
    'dialogCSubTitle': 'You can download the confirmation here',
    'groupTips1': 'You have successfully registered. Please enter with this QR code',
    'groupTips2': 'All access rights have been opened for you',
    'groupTips3': 'Online interactive contact, one touch solution to supply and marketing problems',
}
